import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import RoutesList from "./RoutesList";
import { URL_FORUM, URL_NEWS, URL_NEWS_DETAILS, URL_SHOP, URL_DOWNLOAD, URL_HOME } from "Helpers/Paths";
import Home from 'Components/Home/Home';
import News from 'Components/News/News';
import Forum from 'Components/Forum/Forum';
import NewsDetails from 'Components/News/NewsDetails/NewsDetails';
import Download from "Components/Download/Download";
import PageNotFound from 'Components/PageNotFound';
import { SUPPORT_LANGUAGES } from 'Config'

const LANG_REGEX =  "/:lang([a-z][a-z])?"

function Routes({ lang }) {
    const { REACT_APP_DOWNLOAD_URL } = process.env;
    const createRender = ( RenderComponent, path = '' )=>{
        return ({ match })=>{
             const { lang } = match.params;
             if(!lang || !SUPPORT_LANGUAGES.includes(lang.toLowerCase()) ){
                 return <Redirect to={`/en${path}`} />
             }
             return <RenderComponent />
        }
     }
    return (
        <Switch>
            <Route exact path={`/:lang(${LANG_REGEX})`} render={createRender(Home)} />
            <Route exact path={LANG_REGEX + URL_DOWNLOAD} render={createRender(Download, URL_DOWNLOAD)} />
            <Route exact path={LANG_REGEX + URL_HOME} render={createRender(Home, URL_HOME)} />
            <Route exact path={LANG_REGEX + URL_NEWS} render={createRender(News, URL_NEWS)} />
            <Route exact path={LANG_REGEX + URL_SHOP} render={() => window.location.replace(`${REACT_APP_DOWNLOAD_URL}/${lang}/store/neverwinter/list`)} />
            <Route exact path={LANG_REGEX + URL_FORUM} render={createRender(Forum, URL_FORUM)} />
            <Route exact path={LANG_REGEX + URL_NEWS_DETAILS + ":newsId"} component={createRender(NewsDetails, URL_NEWS)} />
            <Route exact path="/">
                <Redirect to={`/${lang}/`} />
            </Route>

            <Route path={"*"} component={PageNotFound} />
            {/* <ProtectedRoute> */}
            {
                RoutesList.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.component}
                    />
                ))
            }
            {/* </ProtectedRoute> */}

        </Switch>
    );
}

export default Routes;
